export default function parseDataToChartPoints(
  data,
  dataMapper,
  extraDataMapperParams,
) {
  return data.map((item) => dataMapper(item, extraDataMapperParams));
}
